const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class AuthService {
  constructor() {
    this.baseUrl = API_URL;
  }

  async getCsrfToken() {
    const response = await fetch(`${this.baseUrl}/auth/csrf/`, {
      credentials: 'include',
    });
    const data = await response.json();
    return data.csrfToken;
  }

  async login(username, password) {
    const csrfToken = await this.getCsrfToken();
    
    const response = await fetch(`${this.baseUrl}/auth/login/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Erro ao fazer login');
    }
    
    return data;
  }

  loginWithTwitch() {
    window.location.href = `${this.baseUrl}/twitch/login/`;
  }

  linkTwitch() {
    window.location.href = `${this.baseUrl}/twitch/link/`;
  }

  async logout() {
    const csrfToken = await this.getCsrfToken();
    
    const response = await fetch(`${this.baseUrl}/auth/logout/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrfToken,
      },
    });

    return response.ok;
  }

  async checkAuth() {
    try {
      const response = await fetch(`${this.baseUrl}/auth/check/`, {
        credentials: 'include',
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return { isAuthenticated: false, user: null };
    }
  }

  async getCurrentUser() {
    const response = await fetch(`${this.baseUrl}/auth/user/`, {
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error('Não autenticado');
    }
    
    return response.json();
  }
}

const authService = new AuthService();
export default authService;
